<template>
  <div id="company" class="entity">
    <div class="hide-when-embedded content-box content-box-padding">
      <div class="container-fluid container-fluid-responsive">
        <div class="row gutter-responsive">
          <div class="col-12 col-md-7">
            <div class="status-change margin-bottom-2" v-if="warningColor" :class="{ danger: warningColor == 'danger', warning: warningColor == 'warning' }">
                STATUS ÆNDRET TIL {{entity.lastStatusChange ? entity.lastStatusChange.value : entity.company.statusText | uppercase}} <span v-if="entity.lastStatusChange">D. {{entity.lastStatusChange.period.from | date('%-d.%m.%Y')}}</span>
            </div>
            <div class="margin-bottom-1" style="color: #616161"><span class="margin-right-2">Etableret {{entity.companyStartDate | date('%Y')}}</span><div style="margin-top: 8px" class="d-block d-lg-none"></div><span v-if="entity.commerciallyProtected" class="d-block d-lg-inline"><i class="fa fa-exclamation-triangle" style="margin-right: 5px; color:#F6AC15"></i>Reklamebeskyttet</span></div>
            <h1 class="t-name margin-top-0" style="margin-bottom: 8px;">{{entity.company.name}}</h1>
            <div class="contact-info padding-top-1">
              <div>{{entity.company.address1}}, {{entity.company.postalCode}} {{entity.company.city}}, {{entity.company.country}}</div>
              <div>CVR: {{entity.company.localIdentifier}} <button @click="showAlert('CVR-nummeret blev kopieret til udklipsholderen'), $root.trackEvent({eventCategory:'Click', eventAction: 'Kopiér CVR', eventLabel: $route.fullPath})" class="btn btn-xs btn-copy btn-default" :data-clipboard-text="entity.company.localIdentifier" v-clipboard>KOPIER</button></div>
              <div v-if="phoneNumbersToShow.length">
                Telefon 
                <a v-for="(number, idx) in phoneNumbersToShow" :key="number" :href="'tel:' + number">{{idx % 2 == 1 ? ', ' : ''}}{{ number }}</a>
              </div>
              <div v-if="entity.company.website"><a target="_blank" :href="'http://' + entity.company.website.replace('https://', '').replace('http://', '')">{{entity.company.website}}</a></div>

              <div
                v-if="windowSize.width < windowSize.sizes.sm"
                class="padding-top-2 padding-bottom-1 d-flex flex-wrap"
                style="gap: 8px"
              >
                <FollowButton
                  :lassoId="entity.lassoId"
                  :name="entity.company.name"
                  class="plausible-event-name=company+follow+click"
                />
                <!-- ? Copied to Story.vue, consider abstracting if needed for more -->
                <Button
                  v-if="showCreditRatingAd"
                  theme="red"
                  icon="speed"
                  label="Lav gratis kreditvurdering"
                  class="plausible-event-name=creditsafe+signup+click"
                  @click="() => userStore.showLoginToShowCompanyDialog({ lassoId: entity.lassoId, trackingEventName: 'creditsafe+signup+click', ...creditsafeIntro })"
                />
              </div>
            </div>

            <!-- <CompanyContactsCallout
              v-if="hasContacts"
              :contactCollection="contactCollection"
              :goToContacts="goToContacts"
              style="margin: 32px 0"
            /> -->

            <div v-if="hasAccountFigures" class="margin-top-2">
              <hr v-if="!hasContacts">

              <div class="row">
                <div class="col-6 text-center">
                  <donut-chart title="Afkastningsgrad" :key-value="latestAccount.roi" :percentage="true"></donut-chart>
                </div>
                <div class="col-6 text-center">
                  <donut-chart title="Soliditetsgrad" :key-value="latestAccount.solvencyRatio" :percentage="true"></donut-chart>
                </div>
              </div>
              <div class="key-figures" v-if="windowSize.width > windowSize.sizes.sm">
                <hr>
                <div class="row">
                  <div class="col-6 key-figure">
                    <h3>
                      <key-value v-if="latestAccount.grossProfitLoss.value !== null" :key-value="latestAccount.grossProfitLoss" :thousands="true"></key-value>
                      <key-value v-else v-bind:key-value="latestAccount.grossResult" :thousands="true"></key-value>
                    </h3>
                    <span>Bruttofortjeneste {{latestAccount.period.to | date('%Y')}}</span>
                  </div>
                  <div class="col-6 key-figure">
                    <h3><key-value :key-value="latestAccount.profitLossFromOrdinaryActivitiesBeforeTax" :thousands="true"></key-value></h3>
                    <span>Resultat før skat {{latestAccount.period.to | date('%Y')}}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 key-figure">
                    <h3><key-value :key-value="latestAccount.profitLoss" :thousands="true"></key-value></h3>
                    <span>Årets resultat {{latestAccount.period.to | date('%Y')}}</span>
                  </div>
                  <div class="col-6 key-figure">
                    <h3><key-value :key-value="latestAccount.liquidityRatio" :percentage="true"></key-value></h3>
                    <span>Likviditetsgrad {{latestAccount.period.to | date('%Y')}}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="showCompanyResume">
              <hr v-if="hasAccountFigures || !hasContacts">

              <expandable-resume v-if="entity.resume" :resume="entity.resume" :expandable="false" title="Virksomhedsresume"></expandable-resume>
              <div v-else class="loader d-flex">
                <Loader :size="40" class="mr-3" />
                <span>Henter virksomhedsresume..</span>
              </div>
              <!-- <div class="d-block d-md-none margin-top-2 padding-bottom-1"></div> -->
            </div>

          </div>
          <div class="col-12 col-md-5">
            <div class="d-block d-md-none margin-top-2"></div>

            <div
              v-if="windowSize.width > windowSize.sizes.sm"
              class="margin-bottom-2 padding-bottom-1 d-flex flex-wrap"
              style="gap: 8px"
            >
              <FollowButton
                :lassoId="entity.lassoId"
                :name="entity.company.name"
                class="plausible-event-name=company+follow+click"
              />

              <Button
                v-if="showCreditRatingAd"
                theme="red"
                icon="speed"
                label="Lav gratis kreditvurdering"
                class="plausible-event-name=creditsafe+signup+button+click"
                @click="() => userStore.showLoginToShowCompanyDialog({ lassoId: entity.lassoId, trackingEventName: 'creditsafe+signup+button+click', ...creditsafeIntro })"
              />
            </div>

            <expandable-list title="Oplysninger" :open="true" class="text-semimuted">
              <div class="list-element">
                {{entity.company.companyType}}
                <span v-show="(entity.company.employeeCount || entity.company.employees || '0') !== '0'"> med {{ (entity.company.employeeCount || entity.company.employees) | pluralize('ansatte', 'ansat', 'ansatte')}}</span>
              </div>
              <div class="list-element" v-show="entity.company.primaryIndustry">{{entity.company.primaryIndustryCode}}: {{entity.company.primaryIndustry}}</div>
              <div class="list-element" v-show="entity.purpose">{{entity.purpose}}</div>
            </expandable-list>

            <expandable-list v-if="owners.length" title="Ejere" :open="true" class="text-semimuted compact">
              <div class="list-element" v-for="participant in owners.slice(0, 5)" :key="participant.unitNumber"><participant-link :participant="participant" @click.native="$root.trackEvent({eventCategory:'Click', eventAction: 'Ejer', eventLabel: $route.fullPath})" /></div>
              <div v-show="owners.length > 3" class="list-element text-semimuted">
                .. og {{owners.length - 3 | pluralize('andre', 'anden', 'andre')}}
              </div>
              <div class="list-element">
                <LassoxLink trackingEventName="company+ownershipdiagram+link+click" path="ownershipdiagram" class="lassox-link"
                  :dialogOptions="{ lassoxIntro:
                    {
                      title: 'Se ejerdiagram',
                      text: 'Opret en profil og få større indsigt i dansk erhvervsliv. Du får bl.a. adgang til nye værktøjer og flere oplysninger om regnskaber, historik og ejerforhold – alt sammen helt gratis.',
                      image: require('@/assets/img/signup-dialog-ownership.png'),
                      color: 'pink'
                    }
                  }"
                >
                  <Icon icon="account_tree_outline_rounded" size="small" />
                  Se ejerdiagram
                </LassoxLink>
              </div>
            </expandable-list>
            <!-- <expandable-list v-if="trueOwners.length" title="Reelle ejere" :open="true" class="text-semimuted compact">
              <div class="list-element" v-for="participant in trueOwners.slice(0, 5)" :key="participant.unitNumber"><participant-link :participant="participant" @click.native="$root.trackEvent({eventCategory:'Click', eventAction: 'Reelle ejere', eventLabel: $route.fullPath})" /></div>
              <div v-show="trueOwners.length > 5" class="list-element text-semimuted">
                .. og {{trueOwners.length - 5 | pluralize('andre', 'anden', 'andre')}}
              </div>
            </expandable-list> -->
            <expandable-list v-if="management.length" title="Direktion" :open="true" class="text-semimuted compact">
              <div class="list-element plausible-event-name=company+executive+click" v-for="participant in management.slice(0, 5)" :key="participant.unitNumber"><participant-link :participant="participant" /></div>
              <div v-show="management.length > 3" class="list-element text-semimuted">
                .. og {{management.length - 3 | pluralize('andre', 'anden', 'andre')}}
              </div>
              <LassoxLink trackingEventName="company+history+link+click" path="history" class="lassox-link">
                <Icon icon="history" size="small" />
                Se historik
              </LassoxLink>
            </expandable-list>
            <expandable-list v-if="interests.length" title="Interessenter" :open="true" class="text-semimuted compact">
              <div class="list-element" v-for="participant in interests.slice(0, 5)" :key="participant.unitNumber"><participant-link :participant="participant" @click.native="$root.trackEvent({eventCategory:'Click', eventAction: 'Interessent', eventLabel: $route.fullPath})" /></div>
              <div v-show="interests.length > 5" class="list-element text-semimuted">
                .. og {{interests.length - 5 | pluralize('andre', 'anden', 'andre')}}
              </div>
            </expandable-list>
            <expandable-list v-if="board.length" title="Bestyrelse" :open="true" class="text-semimuted compact">
              <div class="list-element plausible-event-name=company+board+click" v-for="participant in board.slice(0, 5)" :key="participant.unitNumber"><participant-link :participant="participant" @click.native="$root.trackEvent({eventCategory:'Click', eventAction: 'Bestyrelsesmedlem', eventLabel: $route.fullPath})" /></div>
              <div v-show="board.length > 5" class="list-element text-semimuted">
                .. og {{board.length - 5 | pluralize('andre', 'anden', 'andre')}}
              </div>
            </expandable-list>
            <expandable-list v-if="entity.lastAccounts.length" title="Regnskaber" :open="true" class="text-semimuted compact">
              <div v-for="(account, index) in entity.lastAccounts.filter(la => !!la.reportUrl)" class="list-element" :key="index">
                <a :href="account.reportUrl" target="_blank" class="plausible-event-name=click+accounts+list">
                  <span class="filetype" :class="{pdf:(account.reportUrl.indexOf('.pdf') > -1 || account.reportUrl.indexOf('.xhtml') > -1), tiff: account.reportUrl.indexOf('.tif') > -1}">{{(account.reportUrl.indexOf('.pdf') > -1 || account.reportUrl.indexOf('.xhtml') > -1) ? 'PDF' : 'TIFF'}}</span>
                  {{account.period.to | date('%Y')}}
                </a>
              </div>
            </expandable-list>
          </div>
        </div>
      </div>
    </div>

    <!-- <webinar-new style="margin-top: 30px" /> -->
    <!-- <ebook style="margin-top: 30px" /> -->

    <div v-if="hasContacts" ref="contactsSectionEl">
      <!-- <CompanyContacts
        :lassoId="entity.lassoId"
        :contactCollection="contactCollection"
      /> -->
    </div>

    <div v-if="entity.lastAccounts.filter(a => a.xbrlUrl).length" class="hide-when-embedded margin-top-2">
      <h2 class="text-center margin-top-bottom-2 padding-top-bottom-1">Regnskaber</h2>
      <div class="content-box content-box-padding ">
        <accounts-viewer :accounts="entity.lastAccounts.filter(a => a.xbrlUrl)" :cvr="entity.company.localIdentifier" :thousands="true" :show-errors="false" />
      </div>
    </div>


    <div class="news-feed-header">
      <news-feed v-if="entity.news" :name="entity.company.name" :news="entity.news" :loading="loadingNews" feed-type="entity-related" :is-query-related="false"></news-feed>
    </div>
  </div>
</template>

<script>
import { store } from '@/assets/js/store.js'
import Directives from '@/assets/js/directives.js'
import { EventBus, Story } from '@/assets/js/helpers.js'
import KeyValue from '@/components/KeyValue'
import DonutChart from '@/components/DonutChart'
import ExpandableList from '@/components/ExpandableList'
import ExpandableResume from '@/components/ExpandableResume'
import ParticipantLink from '@/components/ParticipantLink'
import AccountsViewer from '@/components/AccountsViewer'
import NewsFeed from '@/components/NewsFeed'
import Ebook from '@/components/Ebook'
import FollowButton from '@/components/FollowButton.vue'
import Button from '@/components/Button.vue'
// import CompanyContactsCallout from '@/components/CompanyContactsCallout.vue'
import IconButton from 'vue-lasso-core/components/IconButton.vue'
import Dialog from 'vue-lasso-core/components/Dialog.vue'
import Icon from 'vue-lasso-core/components/Icon.vue'
import LassoxLink from '@/components/LassoxLink.vue'
// import CompanyContacts from '@/components/CompanyContacts/CompanyContacts.vue'
import orderBy from 'lodash/orderBy'
import userStore, { creditsafeIntro } from '@/modules/users/store'
import Loader from '@/components/Loader'
import WebinarNew from '@/components/WebinarNew'
import windowSize from '@/window-size'

let companyFormsToShowResume = ['aktieselskab', 'anpartsselskab', 'iværksætterselskab', 'enkeltmandsvirksomhed', 'interessentskab', 'kommanditselskab', 'kommanditaktieselskab/partnerselskab'] // , 'andelsselskab (-forening) med begrænset ansvar'

async function beforeRouteEnterOrUpdate (to, from, next) {
  const lassoId = to.meta.lassoIdPrefixes + to.params.id

  const entity = await store.dispatch('loadEntity', { lassoId, includeNews: true })

  if (to.query.unfollow == 'true') {
    const unfollow = () => userStore.user.unfollowEntities([{
      lassoId: entity.lassoId,
      name: entity.name,
    }])

    if (!userStore.user) userStore.showLoginDialog({ onLoggedIn: unfollow })
    else unfollow()
  }

  if (entity.company.companyType && companyFormsToShowResume.indexOf(entity.company.companyType.toLowerCase()) > -1) {
    store.dispatch('loadResume', {lassoId, short: false}).then(() => EventBus.$emit('resumeLoaded'))
  }

  const applyData = target => {
    // target.showContactsInfoDialog = false
  }

  if (!this) {
    next(vm => {
      applyData(vm)
    })
  } else {
    applyData(this)
    next()
  }
}

export default {
  name: 'company',
  data () {
    return {
      windowSize,
      userStore,
      loadingNews: false,
      creditsafeIntro,
    }
  },
  computed: {
    entity: function () {
      return this.$store.state.entities['CVR-1-' + this.$route.params.id]
    },
    showCreditRatingAd () {
      return !!this.latestAccount
    },
    warningColor: function () {
      if (this.entity && !RegExp('normal|aktiv', 'i').test(this.entity.company.statusText)) {
        return new RegExp('ophørt|konkurs', 'i').test(this.entity.company.statusText) ? 'danger' : 'warning'
      } else return null
    },
    contactCollection () {
      return this.entity.contactCollection
    },
    hasContacts () {
      return !!this.contactCollection?.contacts.length
    },
    latestAccount: function () {
      return this.entity && this.entity.lastAccounts && this.entity.lastAccounts[0] ? this.entity.lastAccounts[0] : null
    },
    hasAccountFigures: function () {
      return this.latestAccount && this.latestAccount.xmlUrl
    },
    news: function () {
      return this.entity.news ? this.entity.news.items : []
    },
    owners () {
      return orderBy(this.entity.owners.map(o => o.participant), ['newestName'])
    },
    trueOwners () {
      return orderBy(this.entity.trueOwners.map(o => o.participant), ['newestName'])
    },
    management () {
      return orderBy(this.entity.management.map(o => o.participant), ['newestName'])
    },
    board () {
      return orderBy(this.entity.board.map(o => o.participant), ['newestName'])
    },
    interests () {
      return orderBy(this.entity.interests.map(o => o.participant), ['newestName'])
    },
    showCompanyResume () {
      let hiddenIds = [
        'CVR-1-35710779' // klage over at vi blandet tidligere enkeltmandsvirksomheder sammen, fair pointe. Skal tilbage når vi en dag gør dette bedre.
      ]
      if (this.entity && hiddenIds.some(id => id === this.entity.lassoId)) return false
      return this.entity && this.entity.company && this.entity.company.companyType ? companyFormsToShowResume.indexOf(this.entity.company.companyType.toLowerCase()) > -1 : false
    },
    phoneNumbersToShow () {
      let numbersToShow = []
      // start by adding the CVR number
      if (this.entity.company.telephone) numbersToShow.push(this.entity.company.telephone)
      // also include the searced-for phonenumber, if available.
      if (this.$route.query.foundByPhone && this.$route.query.foundByPhone !== this.entity.company.telephone) numbersToShow.push(this.$route.query.foundByPhone)
      return numbersToShow
    }
  },
  methods: {
    loadNews: function (more) {
      var that = this
      if (this.loadingNews || (this.entity.news && (!more || this.entity.news.endReached))) return
      else this.loadingNews = true
      var nextPage = this.entity.news && more ? this.entity.news.page + 1 : 1
      this.$store.dispatch('loadEntityNews', { lassoId: this.entity.lassoId, page: nextPage, count: 12 }).then(() => { this.loadingNews = false })
      // Story.getByLassoIds([this.entity.lassoId], nextPage, 12).then(function (news) {
      //   that.$store.commit('addEntityNews', { lassoId: that.entity.lassoId, news: news, page: nextPage, endReached: news.length < 12 })
      //   that.loadingNews = false
      // })
    },
    // goToContacts () {
    //   let offset = 0

    //   const headerEl = document.getElementById('app-header')
    //   if (headerEl) offset = headerEl.clientHeight

    //   const newScrollTop = this.$refs.contactsSectionEl.offsetTop - offset

    //   const scrollEl = document.body.parentElement

    //   if ('scrollTo' in scrollEl) scrollEl.scrollTo({ top: newScrollTop, behavior: 'smooth' })
    //   else scrollEl.scrollTop = newScrollTop
    // },
    showAlert: function (text) {
      EventBus.$emit('alert', { duration: 3000, content: text })
    }
  },
  beforeRouteEnter: beforeRouteEnterOrUpdate,
  beforeRouteUpdate: beforeRouteEnterOrUpdate,
  mounted: function () {
    var that = this
    EventBus.$on('loadNews', function () { that.loadNews(true) })
  },
  destroyed: function () {
    EventBus.$off('loadNews')
  },
  components: {
    KeyValue,
    DonutChart,
    ExpandableList,
    ExpandableResume,
    ParticipantLink,
    AccountsViewer,
    NewsFeed,
    Ebook,
    ExpandableList,
    FollowButton,
    Button,
    // CompanyContactsCallout,
    IconButton,
    Icon,
    Dialog,
    // CompanyContacts,
    Loader,
    WebinarNew,
    LassoxLink,
  },
  directives: {
    'clipboard': Directives.clipboard,
    'event-on-visible': Directives.eventOnVisible
  }
}
</script>

<style lang="less" scoped>
@import (reference) "~@oldShared/lasso/style/constants/colors";

.status-change {
  border-radius: 2px;
  text-align: center;
  font-size: 11px;
  font-weight: bold;
  padding: 8px;
  &.danger {
    color: @red-primary;
    background-color: #fadddd;
  }
  &.warning {
    color: #cc7606;
    background-color: #f7ebda;
  }
}

h1 {
  color: #212121;
  font-size: 36px;
  line-height: 40px;
  font-weight: 500;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    font-size: 16px;
    color: rgba(97,97,97,.7);
  }
}

.expandable-list {
  &:not(:last-child) {
    margin-bottom: 30px;
  }
}

.contact-info {
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
}

h2 {
  color: #212121;
  font-size: 25px;
  line-height: 28px;
  font-weight: 500;
}

.lassox-link {
  display: flex;
  align-items: center;
  margin-top: 16px;
  gap: 8px;
  color: #FF6B7E;
  .md-icon {
    color:#FF6B7E
  }
}

#app.xxs, #app.xs, #app.sm {
  .account-viewer {
    padding: 0 30px;
  }
}

#app.md, #app.min-md {
  .account-viewer {
    padding: 0 60px;
  }
}
</style>
